/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import Slider$1 from './Slider.js';
import { createClassWrapper } from '../../internal/createClassWrapper.js';
export { default as SliderSkeleton } from './Slider.Skeleton.js';

const Slider = createClassWrapper(Slider$1);

export { Slider, Slider as default };
